export enum ConfirmationCodeEnum {
  Signup = 'Signup',
  UnusualLogin = 'UnusualLogin',
  TwoFA = 'TwoFA'
}

export interface SignInData {
  login: string,
  password: string
}

export interface TokenData {
  token: string,
  refreshToken: string,
  expire: string,
}

export interface RefreshTokenData {
  token: string,
  refreshToken: string,
}

export interface User {
  firstName: string,
  lastName: string,
  email: string,
  password: string,
  referralCode?: number,
  country: string,
  address: string,
  postalCode: number,
  unit?: number,
  floor?: number,
  buzzer?: string,
  whosShipping: string,
  companyName: string,
  website: [string],
  industry: string,
  teamSize: string,
  whereShip: string,
}

export interface Auth {
  isAuth: boolean,
  user: User,
}

export type legacyAuthState = {
  successful: boolean,
}

export type SendConfirmationCodeResponse = {
  attempts: number;
  maxAttempts: number;
  registrationDateTime: string;
  expirationDateTime?: string | null;
};
